// extracted by mini-css-extract-plugin
export default {"container":"SideBarTabReadingOrder_container__fxcVj","readingOrderList":"SideBarTabReadingOrder_readingOrderList__4ctWb"};